const agentType = [
  { key: 'any', value: 'Any' },
  { key: 'self', value: 'Self' },
];
export default agentType;
